module.exports = __webpack_public_path__ + "fba441f1858cf2722f8c3241ad537b9f.svg";